// BFC-9035: The Global Circle Filter selection is persisted in localStorage (unlike the rest of the
// persisted redux state, which lives in sessionStorage - see redux/storageProvider). It is cleared on
// login and logout so a fresh login always starts with "All Circles".
// Kept free of imports so auth/login code can use it without pulling in the redux slice.
export const CIRCLE_FILTER_PERSIST_KEY = 'circleFilter';

export const CIRCLE_FILTER_STORAGE_KEY = `persist:${CIRCLE_FILTER_PERSIST_KEY}`;

export const clearPersistedCircleFilter = () => {
  try {
    localStorage.removeItem(CIRCLE_FILTER_STORAGE_KEY);
  } catch (e) {
    // storage unavailable (private mode / blocked) - nothing to clear
  }
};

// Reads selectedCircleIds from a raw redux-persist localStorage value (used to sync other tabs)
export const parsePersistedCircleIds = (rawValue) => {
  try {
    const persisted = JSON.parse(rawValue || '{}');
    const ids = JSON.parse(persisted.selectedCircleIds || '[]');
    return Array.isArray(ids) ? ids : [];
  } catch (e) {
    return [];
  }
};
